import React from 'react';

import { Item2TitleData } from '../schemas/rql';
import ConditionDisplay from '@reverbdotcom/commons/src/components/condition_display';
import gql from 'graphql-tag';
import BestSellerBadge from './best_seller_badge';
import experiments from '@reverbdotcom/commons/src/experiments';
import { useExpEnabled } from '@reverbdotcom/commons/src/user_hooks';

interface IProps {
  listing: Item2TitleData.Fragment;
}

export const Item2TitleFragment = gql`
  fragment Item2TitleData on Listing {
    _id
    id
    title
    condition {
      conditionSlug
      displayName
    }
    categories {
      _id
      id
      slug
      name
      rootSlug
    }
    csp {
      _id
      id
    }
  }
`;

export function Item2Title({ listing }: IProps) {
  const inCspCtaSidebarExperiment = useExpEnabled(experiments.CSP_CTA_ON_ITEM_SIDEBAR);
  if (!listing) return null;

  return (
    <div className="item2-title">
      <div className="item2-title__inner">
        <h1>
          {listing.title}
        </h1>
        <ConditionDisplay
          slug={listing.condition.conditionSlug}
          displayName={listing.condition.displayName}
          showTooltip
          textOnly
          displayAsTag
        />
        {!inCspCtaSidebarExperiment &&
          <BestSellerBadge
            cspId={listing?.csp?.id}
            listingId={listing?.id}
            categories={listing?.categories}
          />
        }
      </div>
    </div>
  );
}
